import { render, staticRenderFns } from "./SyncModal.vue?vue&type=template&id=39b38a7a&scoped=true"
import script from "./SyncModal.vue?vue&type=script&lang=js"
export * from "./SyncModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b38a7a",
  null
  
)

export default component.exports